var Actions;
(function (Actions) {
    // core
    Actions["LOAD"] = "core/LOAD";
    Actions["UNLOAD"] = "core/UNLOAD";
    Actions["REQUEST"] = "core/REQUEST";
    Actions["REQUEST_SUCCESS"] = "core/REQUEST_SUCCESS";
    Actions["REQUEST_FAIL"] = "core/REQUEST_FAIL";
    Actions["REQUEST_CANCELED"] = "core/REQUEST_CANCELED";
    Actions["WIDGET_DATA_REQUEST"] = "core/WIDGET_DATA_REQUEST";
    Actions["WIDGET_DATA_REQUEST_SUCCESS"] = "core/WIDGET_DATA_REQUEST_SUCCESS";
    Actions["WIDGET_DATA_REQUEST_FAIL"] = "core/WIDGET_DATA_REQUEST_FAIL";
    Actions["WIDGET_DATA_REQUEST_CANCELED"] = "core/WIDGET_DATA_REQUEST_CANCELED";
    Actions["WIDGET_STATE_CHANGED"] = "core/WIDGET_STATE_CHANGED";
    Actions["WIDGET_APPEAR"] = "core/WIDGET_APPEAR";
    Actions["PAGE_CONTAINER_READY"] = "core/PAGE_CONTAINER_READY";
    Actions["WIDGET_READY"] = "core/WIDGET_READY";
    Actions["INITIALIZE"] = "core/INITIALIZE";
    Actions["INITIALIZED"] = "core/INITIALIZED";
    Actions["RESET_WIDGET"] = "core/RESET_WIDGET";
    Actions["PAGE_CONTEXT_CHANGED"] = "core/PAGE_CONTEXT_CHANGED";
    Actions["OC_CONTEXT_CHANGED"] = "core/OC_CONTEXT_CHANGED";
    Actions["FOUND_WIDGETS"] = "core/FOUND_WIDGETS";
    // core/interaction
    Actions["ADD_TO_CART"] = "core/interaction/ADD_TO_CART";
    Actions["ORDER_CONFIRM"] = "core/interaction/ORDER_CONFIRM";
    Actions["USER_LOGIN"] = "core/interaction/USER_LOGIN";
    Actions["ADD_TO_WISHLIST"] = "core/interaction/ADD_TO_WISHLIST";
    Actions["CART_STATUS"] = "core/interaction/CART_STATUS";
    Actions["ITEM_CLICKED"] = "core/interaction/ITEM_CLICKED";
    // Page data actions
    Actions["PAGE_WIDGETS_DATA_REQUEST"] = "core/PAGE_WIDGETS_DATA_REQUEST";
    Actions["PAGE_WIDGETS_DATA_REQUEST_SUCCESS"] = "core/PAGE_WIDGETS_DATA_REQUEST_SUCCESS";
    Actions["PAGE_WIDGETS_DATA_REQUEST_FAIL"] = "core/PAGE_WIDGETS_DATA_REQUEST_FAIL";
    Actions["PAGE_WIDGETS_DATA_REQUEST_CANCELED"] = "core/PAGE_WIDGETS_DATA_REQUEST_CANCELED";
})(Actions || (Actions = {}));
export default Actions;
